import withStyles from '@material-ui/core/styles/withStyles';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import Success from "components/Typography/Success";
import { t } from 'i18next';
import { default as React } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as Score from "utils/Score";
const styles = {};

class Component extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            answers: this.props.answers,
            endMessages: this.props.endMessages,
            questions: this.props.questions,
            score: 0,
            endMessage: ''
        }
    }
    componentDidMount() {
        const answers = this.state.answers
        const questions = this.state.questions
        const score = Score.getScoreOfOneResponse(questions, answers)
        const endMessage = this.getEndMessageForScore(score)
        this.setState({
            score, endMessage
        })
    }
    getEndMessageForScore = (score) => {
        const endMessages = this.state.endMessages
        const message = endMessages.filter(item => (item.from <= score && item.to >= score))[0]
        return message
    }
    render() {
        const { endMessage, score } = this.state;
        const { classes } = this.props
        // Render the CTA labels in the SURVEY's language (what the guest is answering in), not the
        // admin/browser UI language. lng falls back to the current language when not provided.
        const lng = this.props.lang || undefined
        const tr = (key) => t(key, { lng })
        // Review platform links come from the survey owner's Settings. Fall back to the legacy
        // placeId prop for Google if that's all we were given.
        const links = Object.assign({}, this.props.reviewLinks)
        if (!links.google && this.props.placeId) {
            links.google = 'https://search.google.com/local/writereview?placeid=' + encodeURIComponent(this.props.placeId)
        }
        const platforms = [
            { key: 'google', label: 'Google', url: links.google },
            { key: 'tripadvisor', label: 'Tripadvisor', url: links.tripadvisor },
            { key: 'facebook', label: 'Facebook', url: links.facebook },
            { key: 'booking', label: 'Booking.com', url: links.booking },
        ].filter(p => p.url && ('' + p.url).trim())
        // Shown only when the admin enabled it for this score range's end message AND at least
        // one platform link is configured. The admin decides per range (no forced gating).
        const showReview = !!(endMessage && endMessage.show_google_review && platforms.length)
        return <div >
            {/* The end message HTML uses Quill alignment classes (ql-align-*). Quill's CSS is not
                loaded on the public thank-you screen, so restate the few rules the message needs. */}
            <style>{`.gq-endmsg .ql-align-center{text-align:center}.gq-endmsg .ql-align-right{text-align:right}.gq-endmsg .ql-align-justify{text-align:justify}.gq-endmsg a{color:#3b6fd4}.gq-endmsg img{max-width:100%}`}</style>
            <Card>
                <CardBody>
                    {endMessage && <div>
                        {endMessage.image_url && <div style={{ textAlign: 'center' }}><img src={endMessage.image_url} style={{ maxWidth: '100%' }} alt="" /></div>}
                        <div className="gq-endmsg" dangerouslySetInnerHTML={{ __html: endMessage.message }} />
                    </div>}
                    {!endMessage && <Success><h3> {tr('Your Score')}: {score.toFixed(2)}</h3></Success>}
                    {/* Review CTA — one uniform button per configured platform, shown when the admin
                        enabled it for this score range. */}
                    {showReview && <div style={{ textAlign: 'center', marginTop: 18 }}>
                        <div style={{ color: '#5d6d66', marginBottom: 12 }}>{tr('Thank you! Your feedback helps us improve.')}</div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center' }}>
                            {platforms.map(p => (
                                <a key={p.key} href={p.url} target="_blank" rel="noopener noreferrer"
                                    style={{ display: 'inline-block', background: '#2f9e44', color: '#fff', fontWeight: 700, padding: '11px 20px', borderRadius: 9, textDecoration: 'none' }}>
                                    {tr('Review on')} {p.label}
                                </a>
                            ))}
                        </div>
                    </div>}
                </CardBody>
            </Card>
        </div>;
    }
}
const mapStatsToProps = ({ user }) => ({ user });
export default connect(mapStatsToProps)(
   withTranslation()(withStyles(styles, { withTheme: true })(Component))
);